<script setup lang="ts">
import { computed } from 'vue'

import { useCarouselContext } from '@shared/fondof-ui/components/molecules/carousel/useCarouselContext'
import type { HTMLAttributeClass } from '@shared/fondof-ui/types'
import clsx from 'clsx'

const props = defineProps<HTMLAttributeClass>()

const { pagination, mobileScrollbar, canScrollNext, canScrollPrev } =
  useCarouselContext()

const showPagination = computed(() => {
  return pagination && (canScrollNext.value || canScrollPrev.value)
})
</script>

<template>
  <div
    v-if="showPagination"
    :class="
      clsx([
        {
          'hidden sm:flex': mobileScrollbar,
        },
        props.class,
      ])
    "
  >
    <slot />
  </div>
</template>
